const requiresEscalation = (purchaseOrder, costCentres) => {

  if (!purchaseOrder) return false;

  const { lineItems } = purchaseOrder;

  // Group cost centres by price.
  const grouped = lineItems.reduce((obj, li) => {
    const { name } = li.costCentre;
    if (!obj.hasOwnProperty(name)) {
      obj[name] = 0;
    }
    obj[name] += li.totalPrice;
    return obj;
  }, {});

  // Check if any of the totals exceeds the cost centre threshold
  return Object.entries(grouped).some(([name, total]) => {
    return total >= (parseFloat(costCentres[name].threshold) || Number.MAX_VALUE);
  })
}

const getRequiresApprovalReason = (purchaseOrder, savedPurchaseOrder, user, costCentres) => {
  const escalate = requiresEscalation(purchaseOrder, costCentres);
  const usedToEscalate = requiresEscalation(savedPurchaseOrder, costCentres);
  if (user.type != 'admin' && !purchaseOrder.id && escalate)              return 'ESCALATED_CREATED';
  if (user.type === 'admin' && purchaseOrder.status === "approved")       return 'ADMIN_APPROVED';
  if (user.type === 'admin' && purchaseOrder.id)                          return 'ADMIN';
  if (escalate && !usedToEscalate && purchaseOrder.isEditsPreApproved)    return 'ESCALATED_PREAPPROVED';
  if (escalate && !usedToEscalate && purchaseOrder.status === "approved") return 'ESCALATED_APPROVED';
  if (escalate && !usedToEscalate)                                        return 'ESCALATED';
  if (purchaseOrder.status === "approved")                                return 'APPROVED';
}

const getRequiresApprovalOptions = (purchaseOrder, savedPurchaseOrder, user, costCentres) => {

  const reapprovalReason = getRequiresApprovalReason(purchaseOrder, savedPurchaseOrder, user, costCentres);

  let confirmText, autoComment, newStatus, isEscalated;

  switch (reapprovalReason) {
    case 'ESCALATED_CREATED':
      confirmText = 'This PO exceeds a spending threshold and will need to be approved by head office. Continue?';
      isEscalated = true;
      break;
    case 'ADMIN_APPROVED':
      confirmText = 'This PO has already been approved. Are you sure you want to update it?';
      break;
    case 'ADMIN':
      confirmText = 'Are you sure you want to update this purchase order?';
      break;
    case 'ESCALATED_PREAPPROVED':
      confirmText = "Your edited PO exceeds a spending threshold and will need to be approved by head office. Continue?";
      newStatus = 'pending';
      autoComment = `PO edited (escalated automatically)`;
      isEscalated = true;
      break;
    case 'ESCALATED_APPROVED': confirmText = "Your edited PO exceeds a spending threshold and will need to be approved by head office. Continue?";
      newStatus = 'pending';
      autoComment = `PO edited (escalated automatically)`;
      isEscalated = true;
      break;
    case 'ESCALATED': confirmText = "Your edited PO exceeds a spending threshold and will need to be approved by head office. Continue?";
      newStatus = 'pending';
      autoComment = `PO edited (escalated automatically)`;
      isEscalated = true;
      break;
    case 'APPROVED':
      confirmText = "This PO has already been approved. Saving changes will send it back to 'pending', requiring further authorization. Continue?";
      newStatus = 'pending';
      autoComment = `PO edited (sent back to 'Pending' automatically)`;
      break;
    default:
      // continue - just create/update without issue.
  }

  return { confirmText, autoComment, newStatus, isEscalated };
}

export {
  requiresEscalation,
  getRequiresApprovalOptions
}
